
import React from 'react';

const About = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-green-50 to-green-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Contenido de texto */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-green-800 mb-8" style={{ fontFamily: 'Pacifico, serif' }}>
              Sobre Ecoffetours
            </h2>
            
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                <strong>Ecoffetours</strong> nace del amor profundo por la naturaleza y la pasión por compartir la belleza única del páramo boyacense. Somos una agencia de turismo especializada en <strong>ecoturismo sostenible</strong> que opera desde el hermoso municipio de <strong>Mongua, Boyacá</strong>.
              </p>
              
              <p>
                Nuestro compromiso va más allá del turismo tradicional. Creemos firmemente en la <strong>conservación del ecosistema de páramo</strong> y en el desarrollo de un turismo responsable que beneficie tanto a nuestros visitantes como a las comunidades locales.
              </p>
              
              <p>
                Con años de experiencia en <strong>senderismo, avistamiento de aves, camping y fotografía de naturaleza</strong>, nuestro equipo de guías locales certificados te acompañará en cada aventura, compartiendo conocimientos ancestrales sobre la flora, fauna y cultura de la región.
              </p>
            </div>

            <div className="mt-10">
              <h3 className="text-2xl font-bold text-green-800 mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
                ¿Por qué elegir Ecoffetours?
              </h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-green-800">Guías Locales Expertos</h4>
                    <p className="text-sm text-gray-600">Conocimiento profundo del territorio</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-green-800">Turismo Sostenible</h4>
                    <p className="text-sm text-gray-600">Respeto por el medio ambiente</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-green-800">Grupos Pequeños</h4>
                    <p className="text-sm text-gray-600">Experiencias personalizadas</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-green-800">Seguridad Garantizada</h4>
                    <p className="text-sm text-gray-600">Equipos y protocolos certificados</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Imagen y estadísticas */}
          <div className="relative">
            <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-2xl mb-16">
              <img 
                src="https://public.readdy.ai/ai/img_res/8e675ae6eaefb8471a7164d5efdec591.jpg"
                alt="Equipo Ecoffetours"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-green-900/60 via-transparent to-transparent"></div>
              
              <div className="absolute bottom-6 left-6 text-white">
                <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Pacifico, serif' }}>
                  Nuestro Equipo
                </h3>
                <p className="text-sm opacity-90">
                  Guías locales apasionados por la naturaleza
                </p>
              </div>
            </div>

            {/* Estadísticas */}
            <div className="w-full max-w-md mx-auto">
              <div className="bg-white rounded-2xl shadow-xl p-6">
                <div className="grid grid-cols-3 gap-4 text-center">
                  <div>
                    <div className="text-2xl font-bold text-green-600">500+</div>
                    <div className="text-sm text-gray-600">Tours Realizados</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-green-600">98%</div>
                    <div className="text-sm text-gray-600">Satisfacción</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-green-600">12</div>
                    <div className="text-sm text-gray-600">Años Experiencia</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
